<template>
  <v-data-table
    :headers="headers"
    :items="contacts"
    :loading="loading"
    hide-default-footer
    :items-per-page="-1"
    :no-data-text="emptyText"
    mobile-breakpoint="0"
  >
    <template v-slot:item.tier="{ item }">
      <v-chip v-if="item.tier" x-small :color="tierColor(item.tier)" dark>
        Tier {{ item.tier }}
      </v-chip>
    </template>
    <template v-slot:item.lastTouch="{ item }">
      {{ item.lastTouch ? formatDate(item.lastTouch) : "Never" }}
    </template>
    <template v-slot:item.nextDue="{ item }">
      <span :class="item.overdue ? 'red--text font-weight-bold' : ''">
        {{ item.nextDue ? formatDate(item.nextDue) : "—" }}
      </span>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn
        v-if="item.phone"
        icon
        small
        :href="`tel:${item.phone}`"
        title="Call"
      >
        <v-icon small>mdi-phone</v-icon>
      </v-btn>
      <v-btn
        v-if="item.phone"
        icon
        small
        :href="`sms:${item.phone}`"
        title="Text"
      >
        <v-icon small>mdi-message-text</v-icon>
      </v-btn>
      <v-btn
        small
        color="primary"
        text
        :to="{ path: '/crm/log', query: { contact: item.id } }"
      >
        Log
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import format from "date-fns/format";

export default {
  props: {
    contacts: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    emptyText: { type: String, default: "No contacts" }
  },
  data() {
    return {
      headers: [
        { text: "Name", value: "name" },
        { text: "Tier", value: "tier", width: "90px" },
        { text: "Type", value: "contactType.name", width: "140px" },
        { text: "Last Touch", value: "lastTouch", width: "120px" },
        { text: "Next Due", value: "nextDue", width: "120px" },
        { text: "", value: "actions", sortable: false, width: "160px" }
      ]
    };
  },
  methods: {
    formatDate(date) {
      // Date-only strings (YYYY-MM-DD) parse as UTC midnight; force local time
      let d = /^\d{4}-\d{2}-\d{2}$/.test(date)
        ? new Date(`${date}T00:00:00`)
        : new Date(date);
      return format(d, "MMM dd");
    },
    tierColor(tier) {
      const colors = { 1: "green", 2: "blue", 3: "grey" };
      return colors[tier] || "grey";
    }
  }
};
</script>

<style scoped lang="scss"></style>
